<template>
    <div class="minidiv">
        <b-modal :id="'modal-remove_'+sn" centered title="Confirm remove" ok ok-variant="success" cancel-variant="danger" @ok="deletecontent()">
            <template v-slot:modal-ok> Yes, Remove </template>
            <p>Are You sure you want to remove {{ content.title }} from contents??</p>
        </b-modal>

        <b-modal :id="'modal-send_'+sn" centered hide-footer title="Send out Content">
            <form @submit.prevent="sendcontent">

                <b-form-group label="Target" class="label" label-for="target">
                    <b-form-group>
                      <b-form-select v-model="send.target">
                          <b-form-select-option value="whatsapp">Whatsapp</b-form-select-option>
                          <b-form-select-option value="email">Email</b-form-select-option>
                          <b-form-select-option value="wapp+email">Whatsapp + Email</b-form-select-option>
                          <b-form-select-option value="smhandles">Social media handles</b-form-select-option>
                          <b-form-select-option value="all">All Channels</b-form-select-option>
                      </b-form-select>
                  </b-form-group>
                </b-form-group>

                <b-form-group label="Receivers Data" class="label" label-for="target">
                    <b-form-group>
                      <b-form-select v-model="send.receivers">
                            <b-form-select-option value="all-users">All Users</b-form-select-option>
                            <b-form-select-option value="non-users">Non Users</b-form-select-option>
                            <b-form-select-option value="premium-users">Premium Users</b-form-select-option>
                            <b-form-select-option value="unverified-users">Whatsapp + Email</b-form-select-option>
                            <b-form-select-option value="users-with-testtaken">Users with at Least a Test taken</b-form-select-option>
                            <b-form-select-option value="users-with-notest">Users with that have not taken any test.</b-form-select-option>
                            <b-form-select-option value="users-7days-practice">Users with Last Practice > 7 days.</b-form-select-option>
                      </b-form-select>
                  </b-form-group>
                </b-form-group>

                <b-form-group label="Receivers Numbers" v-if="send.receivers == 'non-users'" label-for="takers">
                    <b-form-tags
                        input-id="tags-separators"
                        v-model="send.numbers"
                        separator=","
                        placeholder="Enter recipients numbers separated by Comma"
                        class="tag-input"
                    ></b-form-tags>
                    {{ send.numbers.length }} Numbers entered
                </b-form-group>

                <b-form-group label="Receivers Emails" v-if="send.receivers == 'non-users'" label-for="takers">
                    <b-form-tags
                        input-id="tags-separators"
                        v-model="send.emails"
                        separator=","
                        placeholder="Enter recipients emails separated by Comma"
                        class="tag-input mt-2"
                    ></b-form-tags>
                    {{ send.emails.length }} Emails entered
                </b-form-group>
    
                <b-form-group label="Send Time" v-slot="{ ariaDescribedby }">
                    <span class="info-span">All Scheduled Contents for Sending are sent in the Morning of the Scheduled date.</span>
                    <b-form-radio v-model="send.timetosend" name="timetosend" :aria-describedby="ariaDescribedby" value="now">Send immediately</b-form-radio>
                    <b-form-radio v-model="send.timetosend" name="timetosend" :aria-describedby="ariaDescribedby" value="schedule">Schedule</b-form-radio>
                </b-form-group>

                <b-form-group v-if="send.timetosend == 'schedule'"  label="Content Release Date" class="label" label-for="releasedate">
                  <b-form-datepicker
                    v-model="send.scheduleddate"
                    :min="new Date()"
                    placeholder="Choose a Date"
                    required
                  ></b-form-datepicker>
                </b-form-group>

                <div v-if="sent" class="alert alert-success p-3">
                    Content Sent Successfully
                </div>

                <div class="text-center">
                    <b-overlay
                        :show="sending"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=""
                    >
                        <div class="mt-4">
                            <b-button :disabled="chkfields" type="submit" variant="outline-success" class="m-lg-3 mt-2 p-2 action-button"> {{ send.timetosend == 'schedule' ? 'Schedule' : 'Send'}} Content </b-button>
                        </div>                  
                    </b-overlay>

                    <b-button v-if="sending" @click="sending = false" class="w-50 p-2 mt-3" variant="dark">
                        Continue sending in Background
                    </b-button>

                </div>
            </form>
        </b-modal>

        <b-modal :id="'modal-preview_'+sn" centered :title="'Preview Content : ' + content.title">
            <template v-slot:modal-footer>
                <b-link :to="{ name : 'editcontent', params : { trackid : content.trackid }}"><b-button class="p-2" variant="info">Edit Content</b-button></b-link>
                <b-button class="p-2" variant="success" @click="sendModal()">Send Content</b-button>
            </template> 
            <p class="subject">{{ content.subject }}</p>
            <img :src="content.cover_image" class="cover-image"/>
            <div v-html="content.body" class="content-body mt-3"></div>
        </b-modal>

        <div class="flex-parent text-center p-1">
            <p class="flex-child">{{ sn + ((page - 1) * interval) }}</p>
            <p class="flex-child"><b-link @click="$bvModal.show(`modal-preview_${sn}`)">{{ content.title }}</b-link></p>
            <p class="flex-child">{{ content.subject }}</p>
            <p class="flex-child" v-html="content.body.slice(0, 70)+ '...'"></p>
            <p class="flex-child">{{ content.target }}</p>
            <p class="flex-child">{{ content.release_date }}</p>
            <p class="flex-child"><a :href="content.cover_image" target='_blank'>{{ content.cover_image }}</a></p>
            <p>
                <b-button :disabled="content.clearance == 'Org Super Admin'" class="p-1 m-1 list-button" variant="danger" @click="comfirmDelete()">Delete</b-button><br>
                <b-button :disabled="content.clearance == 'Org Super Admin'" class="p-1 M-1 list-button" variant="success" @click="sendModal()">Send</b-button>
            </p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    props: ["content", 'sn', 'page', 'interval'],
    data() {
        return {
            overallscore: 0,
            send: this.getForm(),
            sending: false,
            sent : false,
        };
    },
    methods: {
        ...mapActions("admin",["delcontent", "fetchContents", "sendContent"]),
        comfirmDelete(){
            this.$bvModal.show(`modal-remove_${this.sn}`);
        },
        sendModal(){
            this.$bvModal.show(`modal-send_${this.sn}`);
        },
        deletecontent(){
            let contentObj = {
                trackid : this.content.trackid
            }

            // console.log(contentObj);

            return this.delcontent(contentObj).then(() => {
                this.fetchContents();
                // console.log(response)
            })
        },
        getForm() {
            return {
                target : "all",
                receivers: "all-users",
                timetosend : "now",
                numbers : [],
                emails : [],
                scheduleddate : "",
                trackid : "",
                adminname: "",
                admintrackid: "",
            };
        },
        sendcontent() {
            this.sending = true;
            // this.user.organization = this.details.clearance_organization
            this.send.trackid = this.content.trackid
            this.send.adminname = this.details.fullname
            this.send.admintrackid = this.details.trackid

            return this.sendContent(this.send).then(() => {
                this.sending = false;
                this.sent = true

                // this.$bvModal.hide(`modal-send_${this.sn}`);

                // this.fetchContents();
            });
        },
    },
    computed: {
        ...mapState({
            allinstitutions: state => state.admin.listinstitutions,
            details : state => state.loginmaster.details,
        }),
        chkfields(){
            if( this.sending || this.send.target.length <= 0 ||
                this.send.receivers.length <= 0 || this.send.timetosend.length <= 0){
                return true
            }else{
                return false
            }
        },
    }
};
</script>

<style scoped>
.minidiv {
    border-radius: 10px 10px;
    background-color: white;
    /* padding: 5px; */
}

.rins {
    font-size: 0.75rem;
}

.lowscore {
    color: red;
}

.highscore {
    color: #00377b;
}

.totsco {
    color: #00377b;
    font-weight: bolder;
}

.brel {
    text-decoration: none;
    color: black;
}
.link-sol{
  text-decoration : none;
  color :  #00984a;
}

.flex-parent {
    display: flex;
    flex-flow: row wrap;
    overflow : auto;
    scrollbar-width: thin;
    /* height: 35px; */
}

.flex-child {
    width: 11%;
    overflow : auto;
    scrollbar-width: thin;
}
.cover-image{
    width: 100%;
}
.subject {
    font-size: 2rem;
    font-weight: bold;
}
@media screen and (max-width: 768px) {
     .flex-child{
        font-size: 0.6rem
    }
    .link-sol{
        font-size: 0.7rem
    }
    .list-button{
        width: contain;
        font-size: 0.6rem;
        padding: 3px;
    }
}
</style>
